import { useEffect } from "react";

// Lightweight SEO meta manager (no dependency). Sets title + meta tags.
export default function Seo({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (title) document.title = `${title} | Velyrea`;
    const set = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    set("description", description);
    set("og:title", title ? `${title} | Velyrea` : "Velyrea", "property");
    set("og:description", description, "property");
    set("og:type", "website", "property");
    const canon = canonical || (typeof window !== "undefined" ? window.location.href : "");
    if (canon) {
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canon);
    }
    // JSON-LD structured data
    let script = document.getElementById("velyrea-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "velyrea-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    return () => {
      const s = document.getElementById("velyrea-jsonld");
      if (s) s.remove();
    };
  }, [title, description, canonical, jsonLd]);
  return null;
}
